import styled from 'styled-components'

import { COLOURS } from 'resources'
import { arrowDropDown } from 'resources/images'

export const Container = styled.div`
  width: 100%;
`

export const Select = styled.select`
  display: block;
  font-size: 18px;
  color: ${COLOURS.neutralBlack};
  padding: 0.6em 1.4em 0.5em 0.8em;
  width: 100%;
  border: 0;
  border-bottom: 2px solid ${COLOURS.neutralBlack};
  border-radius: 0;
  appearance: none;
  background-color: ${COLOURS.white};
  background-image: url(${arrowDropDown});
  background-repeat: no-repeat, repeat;
  background-position: right 0.7em top 50%, 0 0;
  background-size: 0.65em auto, 100%;
  outline: none;
  transition: all 0.3s;

  ::-ms-expand {
    display: none;
  }

  &:focus {
    border-bottom-color: ${COLOURS.secondaryPurple1};
  }
`

export const Option = styled.option`
  font-weight: normal;
`
